export const windowsService = {
  openInNewWindow: (url?: string): void => {
    window.open(url, "_blank");
  },
  createBlankPage: (): WindowProxy | null => window.open("about:blank", "_new"),
  goTo: ({ url }: { url: string }): void => {
    window.location.href = url;
  },
  reloadPage: (): void => window.location.reload(),
};
